import { useEffect, useState } from "react";
import download from "../../../assets/download.png";
import ActivateCard from "../../../Components/Cards/ActivateCard/ActivateCard";
import "./Report.css";
// import Status from "./Status";
import moment from "moment";
import CsvDownload from "react-json-to-csv";
import { Link } from "react-router-dom";
import downarrow from "../../../assets/downarrow.png";
import uparrow from "../../../assets/uparrow.png";
import CustomDatePicker from "../../../Components/CustomDatePicker/CustomDatePicker";
import { useSearch } from "../../../context/SearchContext";
import api from "../../../utils/api";

const Report = () => {
  const { search } = useSearch();
  const [data, setData] = useState([]);
  const [paid, setPaid] = useState("none");
  const [filterPaid, setFilterPaid] = useState(false);
  const [filterUnpaid, setFilterUnpaid] = useState(false);

  const [filterClass, setFilterClass] = useState("");
  const [filterSection, setFilterSection] = useState("");

  const [isModal, setIsModal] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterDate, setFilterDate] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [sortBy, setSortBy] = useState("asc");
  const [summary, setSummary] = useState(null);

  const [downloadData, setDownloadData] = useState([]);
  const [downloadFilteredData, setDownloadFilteredData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const fetchClasses = async () => {
    const response = await api.get("/feesreport/getclasses");
    setClasses(
      response.data?.map((el) => {
        return {
          value: el,
          label: el,
        };
      })
    );
  };

  const fetchData = async () => {
    api
      .get(
        "/feesreport?search=" +
        search +
        "&fromDate=" +
        startDate +
        "&toDate=" +
        endDate +
        "&page=" +
        pagination.page +
        "&limit=" +
        pagination.limit
      )
      .then((response) => response.data)
      .then((data) => {
        setSummary(data?.summary);
        let sortedData = data?.data?.map((el) => {
          return {
            gr: el.gr,
            name: el.name,
            section: el.section,
            class: el.class,
            late_date: moment(el.late_date).format("DD-MM-YYYY"),
            payment_date: el.payment_date
              ? moment(el.payment_date).format("DD-MM-YYYY")
              : "NA",
            month: el.month,
            tution: el.tution,
            computer: el.computer,
            miscellaneous: el.miscellaneous,
            admission_fee: el.admission_fee,
            term_fee: el.term_fee,
            late: moment(new Date()) > moment(el.late_date) ? el.late : "NA",
            total:
              parseInt(el.total) +
              parseInt(moment(new Date()) > moment(el.late_date) ? el.late : 0),
            status: el.status,
            fee_setup_id: el.fee_setup_id,
            id: el.id,
          };
        });
        setData(data?.data);
        setDownloadData(sortedData);
        // setPagination(data?.summary);
        if (data?.summary?.page && data?.summary?.limit) {
          setPagination({
            page: data.summary.page,
            limit: data.summary.limit,
            total: data.summary.total || 0,
            totalPages: data.summary.totalPages || 0,
          });
        }
      });
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    fetchData();
  }, [search, pagination.page, pagination.limit]);

  const handleFilter = () => {
    // Always work with a copy and check for array
    let newData = Array.isArray(data) ? [...data] : [];

    // Filter by paid/unpaid
    if (filterPaid) {
      newData = newData.filter((el) => el.status === "paid");
      setFilter(true);
    } else if (filterUnpaid) {
      newData = newData.filter((el) => el.status === "unpaid");
      setFilter(true);
    }

    // Filter by date range (if both dates are set)
    if (filterDate && startDate && endDate) {
      newData = newData.filter((el) => {
        const lateDate = moment(el.late_date, "DD-MM-YYYY");
        const from = moment(startDate);
        const to = moment(endDate);
        return lateDate.isBetween(from, to, undefined, "[]");
      });
      setFilter(true);
    }

    // Filter by class
    if (filterClass !== "") {
      newData = newData.filter((el) => el.class === filterClass);
      setFilter(true);
    }

    // Filter by section
    if (filterSection !== "") {
      newData = newData.filter((el) => el.section === filterSection);
      setFilter(true);
    }

    // Prepare download data
    let sortedDownloadData = newData.map((el) => ({
      gr: el.gr,
      name: el.name,
      section: el.section,
      class: el.class,
      late_date: moment(el.late_date).format("DD-MM-YYYY"),
      payment_date: el.payment_date
        ? moment(el.payment_date).format("DD-MM-YYYY")
        : "NA",
      month: el.month,
      tution: el.tution,
      computer: el.computer,
      miscellaneous: el.miscellaneous,
      admission_fee: el.admission_fee,
      term_fee: el.term_fee,
      late: moment(new Date()) > moment(el.late_date) ? el.late : "NA",
      total:
        parseInt(el.total) +
        parseInt(moment(new Date()) > moment(el.late_date) ? el.late : 0),
      status: el.status,
      fee_setup_id: el.fee_setup_id,
      id: el.id,
    }));

    setFilteredData(newData);
    setDownloadFilteredData(sortedDownloadData);
    setFilter(true);
  };

  // --- Totals Calculation ---
  // Use filtered data if filter is active, else use all data
  const displayData = filter ? filteredData : data;

  // Helper to get total for a row (including late fee if applicable)
  const getRowTotal = (row) => {
    const lateFee =
      moment(new Date()) > moment(row.late_date) && row.late
        ? parseInt(row.late)
        : 0;
    return parseInt(row.total) + lateFee;
  };

  // Calculate totals
  const totalAmount = summary?.totalFees;
  const paidAmount = summary?.paidFees;
  const unpaidAmount = summary?.unpaidFees;

  useEffect(() => {
    let sortedData = [...displayData].sort((a, b) => {
      const dateA = moment(a.late_date, "DD-MM-YYYY").valueOf();
      const dateB = moment(b.late_date, "DD-MM-YYYY").valueOf();
      return sortBy === "asc" ? dateA - dateB : dateB - dateA;
    });

    if (filter) {
      setFilteredData(sortedData);
    } else {
      setData(sortedData);
    }
  }, [sortBy, filter]);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  return (
    <div className="report" >
      {isModal ? (
        <ActivateCard
          action={() => {
            if (paid === "none") {
              setPaid("paid");
            } else if (paid === "paid") {
              setPaid("unpaid");
            } else {
              setPaid("paid");
            }
            setIsModal(0);
          }}
          close={() => {
            setIsModal(0);
          }}
        />
      ) : null}
      <div className="report__top">
        <div className="report__top_left">
          <div className="report__top_button">
            <CustomDatePicker
         value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setFilterDate(true);
              }}
            />
          </div>
          <div
            className="report__top_button"
            style={{ textAlign: "auto" }}
          >
            <h5 style={{ display: "block", margin: "auto" }}>to</h5>
          </div>
          <div className="report__top_button">
            <CustomDatePicker
           value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setFilterDate(true);
              }}
            />
          </div>
          <div className="report__top_button">
            <select
              value={filterClass}
              style={{
                fontFamily: "monospace",
                paddingLeft: "10px",
                marginLeft: "10px",
                borderColor: '#CCCCCC',
                borderRadius: '5px',
                backgroundColor: "rgb(229,229,229)"
              }}
              onChange={(e) => setFilterClass(e.target.value)}
            >
              <option value="">select class</option>
              {classes.map((el) => (
                <option value={el.value} key={el.value}>
                  {el.label}
                </option>
              ))}
            </select>
            <select
              value={filterSection}
              style={{
                fontFamily: "monospace",
                paddingLeft: "10px",
                marginLeft: "20px",
                borderColor: '#CCCCCC',
                borderRadius: '5px'
                , backgroundColor: "rgb(229,229,229)"
              }}
              onChange={(e) => setFilterSection(e.target.value)}
            >
              <option value="">select section</option>
              <option value="pre-primary">Pre-Primary</option>
              <option value="pre-nursery">Pre-Nursery</option>
              <option value="nursery">Nursery</option>
              <option value="primary">Primary</option>
              <option value="secondary">Secondary</option>
            </select>
          </div>
          <div className="report__top_button">
            <button
              type="button"
              className="report__top_button_go"
              onClick={handleFilter}
              style={{ height: "40px" }}
            >
              Go
            </button>
            <button
              type="button"
              className="report__top_button_go"
              onClick={() => {
                setFilter(false);
                setFilterPaid(false);
                setFilterClass("");
                setFilterSection("");
                setFilterDate(false);
                setFilterUnpaid(false);
                 setStartDate(""); // <-- Add this line
    setEndDate("");   // <-- Add this line
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div className="report__top" style={{ margin: "10px 0" }}>
        <div className="report__top_button">
          <button
            type="button"
            className="report__top_button_date"
            style={
              filterPaid
                ? { backgroundColor: "#e6e3e3" }
                : { backgroundColor: "#fff" }
            }
            onClick={() => {
              setFilterPaid(true);
              setFilterUnpaid(false);
            }}
          >
            Paid
          </button>
          <button
            type="button"
            className="report__top_button_date"
            style={
              filterUnpaid
                ? { backgroundColor: "#e6e3e3" }
                : { backgroundColor: "#fff" }
            }
            onClick={() => {
              setFilterUnpaid(true);
              setFilterPaid(false);
            }}
          >
            Unpaid
          </button>
        </div>
        <div className="report__top" style={{ justifyContent: "start" }}>
          <CsvDownload
            data={filter === true ? downloadFilteredData : downloadData}
            className="report__top_button_button"
            filename="export.csv"
          >
            <img
              className="report__top_button_img"
              src={download}
              alt="upload"
            />
            Download
          </CsvDownload>
          <CsvDownload
            data={downloadData}
            className="report__top_button_button"
            filename="export.csv"
          >
            <img
              className="report__top_button_img"
              src={download}
              alt="upload"
            />
            Download All
          </CsvDownload>
        </div>
      </div>

      {/* Totals Section */}
      <div
        className="report__totals"
        style={{ margin: "20px 0", fontWeight: "bold", fontSize: "1.1em" }}
      >
        <span style={{ marginRight: "30px" }}>
          Total Amount: ₹{totalAmount}
        </span>
        <span style={{ marginRight: "30px" }}>Paid Amount: ₹{paidAmount}</span>
        <span>Unpaid Amount: ₹{unpaidAmount}</span>
      </div>

      <div className="report__middle">
        <table>
          <tr className="report__middle_tr">
            <th className="report__middle_th">GR Number</th>
            <th className="report__middle_th">Name</th>
            <th className="report__middle_th">Section</th>
            <th className="report__middle_th">Class</th>
            <th className="report__middle_th">
              Due Date{" "}
              {sortBy == "asc" ? (
                <img
                  src={uparrow}
                  alt="uparrow"
                  style={{
                    height: 15,
                    width: 15,
                    marginBottom: 0,
                    marginLeft: 5,
                  }}
                  onClick={() => {
                    setSortBy("desc");
                  }}
                />
              ) : (
                <img
                  src={downarrow}
                  alt="downarrow"
                  style={{
                    height: 15,
                    width: 15,
                    marginBottom: 0,
                    marginLeft: 5,
                  }}
                  onClick={() => {
                    setSortBy("asc");
                  }}
                />
              )}
            </th>
            <th className="report__middle_th">Payment Date</th>
            <th className="report__middle_th">Month</th>
            <th className="report__middle_th">Tution Fee</th>
            <th className="report__middle_th">Computer Fee</th>
            <th className="report__middle_th misc">Miscellaneous Fee</th>
            <th className="report__middle_th misc">Admission Fee</th>
            <th className="report__middle_th misc">Term Fee</th>
            <th className="report__middle_th">Late Fee</th>
            <th className="report__middle_th">Due Amount</th>
            <th className="report__middle_th">Payment Receipt</th>
            <th className="report__middle_th">Payment Status</th>
          </tr>
          <tbody>
            {Array.isArray(data) &&
              displayData.map((data) => {
                return (
                  <tr className="report__middle_tr scroll" key={data.id}>
                    <td className="report__middle_td">
                      <Link
                        to={`/fee_report/${data.id}`}
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        {data.gr || "-"}
                      </Link>
                    </td>
                    <td className="report__middle_td">{data.name || "-"}</td>
                    <td className="report__middle_td">{data.section || "-"}</td>
                    <th className="report__middle_th">{data.class || "-"}</th>
                    <td className="report__middle_td">
                      {data.late_date ? moment(data.late_date).format("DD-MM-YYYY") : "-"}
                    </td>
                    <td className="report__middle_td">
                      {data.payment_date ? moment(data.payment_date).format("DD-MM-YYYY") : "-"}
                    </td>
                    <td className="report__middle_td">{data.month || "-"}</td>
                    <td className="report__middle_td">{data.tution ?? "-"}</td>
                    <td className="report__middle_td banner">{data.computer ?? "-"}</td>
                    <td className="report__middle_td">{data.miscellaneous ?? "-"}</td>
                    <td className="report__middle_td">{data.admission_fee ?? "-"}</td>
                    <td className="report__middle_td">{data.term_fee ?? "-"}</td>
                    <td className="report__middle_td">
                      {data.late_date
                        ? moment(new Date()) > moment(data.late_date)
                          ? data.late ?? "-"
                          : "-"
                        : "-"}
                    </td>
                    <td className="report__middle_td">
                      {data.total
                        ? parseInt(data.total) +
                        parseInt(
                          moment(new Date()) > moment(data.late_date)
                            ? data.late ?? 0
                            : 0
                        )
                        : "-"}
                    </td>
                    <td className="report__middle_td">
                    {data.payment_receipt ? (
                      <a
                        href={data.payment_receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "underline" ,color: "green",cursor: "pointer" }}
                      >
                        View 
                      </a>
                    ) : (
                      "-"
                    )}
                    </td>
                    <td className="report__middle_td">
                      <div>
                        <button
                          type="button"
                          className={`report__middle_td_status ${data.status !== "unpaid" ? "paid" : "unpaid"
                            }`}
                        >
                          {data.status !== "unpaid" ? "Paid" : "Unpaid"}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
         
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1 || 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination?.page || 1} of {pagination?.totalPages || 1}
        </span>


        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>
        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: parseInt(e.target.value),
                page: 1, // Reset to first page when changing limit
              }));
            }}
            style={{
              padding: "5px 10px",
              marginLeft: "10px",
              backgroundColor: "rgb(229,229,229)",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Report;
// const handleFilter = () => {
//   if (filterPaid) {
//     fetch(
//       `${process.env.REACT_APP_BASE_URL}/feereport/unpaid=${filterUnpaid}`
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         setData(data);
//       });
//   }
//   if (startDate) {
//     fetch(`${process.env.REACT_APP_BASE_URL}/feereport/?dt=${startDate}`)
//       .then((response) => response.json())
//       .then((data) => {
//         setData(data);
//       });
//   }
//   // fetch(
//   //   `process.env.REACT_APP_BASE_URL/feereport/paid=${filterPaid}/unpaid=${filterUnpaid}`
//   // )
//   //   .then((response) => response.json())
//   //   .then((data) => {
//   //     setData(data);
//   //   });
//   // console.log(filterPaid);
// };
